import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InfoPageComponents from "../components/core/auth/InfoPageComponents";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import PublicLayout from "../layouts/PublicLayout";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";


const ErrorPage = () => {
    const {t} = useTranslation();

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.error")}</title>
                <meta name="description" content={t("page.title.error")}/>
            </Helmet>

            <PublicLayout>
                <InfoPageComponents caption="error-page.info" icon={<InfoOutlinedIcon/>} redirectToStartPage/>
            </PublicLayout>
        </AuthorizedContextProvider>
    );
};

export default ErrorPage;